export enum TipoAtendimentoUsuario {
    ApenasVirtual = 0,
    ApenasPresencial = 1,
    VirtualEPresencial = 2,
}
